@if (collar$ | async; as collar) {
  @if (pet$ | async; as pet) {
    @if (private$ | async; as private) {
      <dl>
        <dt>Temperature alerts</dt>
        <dd>{{collar.lower_temp_alert}}°C — {{collar.upper_temp_alert}}°C</dd>
        <dt>Safe zones synced</dt>
        <dd>{{private.safe_zones_synced}}</dd>
        <dt>Stride lengths</dt>
        <dd><a href="https://seq.infra.averia.tech/#/events?filter={{encode(pet.id)}}" target="_blank"> {{(private.stride_lengths.step * 100) | number:'1.0-1':'en'}}, {{(private.stride_lengths.run * 100) | number:'1.0-1':'en'}}, {{(private.stride_lengths.gallop * 100) | number:'1.0-1':'en'}}</a></dd>
      </dl>
    }
    <!--    <div class="head">-->
    <!--      Today-->
    <!--      <span *ngIf="pet.goal"-->
    <!--            class="goal">-->
    <!--        {{(collar.activity.distance * 100 / pet.goal) | number:'1.0-0':'en'}}% of daily goal-->
  <!--      </span>-->
<!--    </div>-->
<!--    <div class="progressbar">-->
<!--      <div class="progress"-->
<!--           [ngStyle]="{'width.%': completion(collar.activity.distance, pet.goal)}"></div>-->
<!--    </div>-->
<!--    <div class="cards">-->
<!--      <div class="card distance">-->
<!--        {{(collar.activity.distance / 1000) | number:'1.0-1':'en'}} km-->
<!--        <span class="desc">Distance</span>-->
<!--      </div>-->
<!--      <div class="card rest">-->
<!--        {{collar.activity.rest | duration | moment:'\xa0HH:mm:ss'}}-->
<!--        <span class="desc">Rest</span>-->
<!--      </div>-->
<!--      <div class="card steps">-->
<!--        {{collar.activity.steps | number:'1.0-0':'fr-FR'}}-->
<!--        <span class="desc">Steps</span>-->
<!--      </div>-->
<!--&lt;!&ndash;      <span>{{collar.activity.duration | duration | moment:'HH:mm:ss'}},&nbsp;</span>&ndash;&gt;-->
<!--    </div>-->
}
}
